import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__ from "@radix-ui/react-dialog";
import * as __WEBPACK_EXTERNAL_MODULE__icons_close_mjs_6b15a222__ from "../../icons/close.mjs";
const DialogContent = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ children, container, showClose = true, ...props }, forwardedRef)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Portal, {
        container: container,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Overlay, {
                className: "inset-0 ptw-fixed ptw-right-0 ptw-top-0 ptw-z-[7000] ptw-h-screen ptw-w-screen ptw-bg-secondary-action ptw-opacity-strong"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Content, {
                ...props,
                ref: forwardedRef,
                children: [
                    children,
                    showClose && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Close, {
                        "aria-label": "Close",
                        className: "ptw-absolute ptw-right-4 ptw-top-4 ptw-z-[7002] ptw-cursor-pointer ptw-border-none ptw-bg-utils-transparent",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__icons_close_mjs_6b15a222__["default"], {
                            width: 24
                        })
                    })
                ]
            })
        ]
    }));
DialogContent.displayName = 'DialogContent';
const Dialog = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Root;
const DialogTrigger = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Trigger;
export { Dialog, DialogContent, DialogTrigger };
